<template>
    <div class="recharge-agreement">
  
      <section class="section">
        <h2 class="section-title">充值说明：</h2>
        <p class="section-content">
          本协议是会员（以下简称“用户”）与【杭州初六科技有限公司】之间关于用户在【蛛网X】应用程序中进行充值的法律协议。用户在进行充值前应仔细阅读本协议的全部内容，如有任何疑问，应及时与我们联系。
        </p>
      </section>
  
      <section class="section">
        <h2 class="section-title">充值方式和费用：</h2>
        <p class="section-content">
          用户可以选择在蛛网X应用程序中使用的充值方式进行充值，具体充值方式和费用将在应用程序中进行明示。充值过程中产生的相关费用将由用户承担，并根据用户选择的支付方式进行支付。
        </p>
      </section>
  
      <section class="section">
        <h2 class="section-title">充值服务：</h2>
        <p class="section-content">
          用户成功充值后，将获得相应金额的会员权益，具体充值服务内容将在应用程序中进行明示。充值服务一经购买成功，不可退换、转让或提现。
        </p>
      </section>
  
      <section class="section">
        <h2 class="section-title">充值安全：</h2>
        <p class="section-content">
          用户应妥善保管个人账户信息，不得将账户信息泄露给他人。用户应对其账户下的一切行为负责。如发现账户异常情况或存在安全隐患，用户应及时通知我们并采取必要的措施以保护账户安全。
        </p>
      </section>
  
      <section class="section">
        <h2 class="section-title">免责条款：</h2>
        <p class="section-content">
          我们不对以下情形造成的损失承担责任：<br>
          用户因自身原因导致的充值失败或错误。<br>
          用户因操作失误导致的账户信息泄露或丢失。
          <br>
        </p>
      </section>
  
      <section class="section">
        <h2 class="section-title">协议的变更和解释：</h2>
        <p class="section-content">
          我们有权根据业务需要随时修改本协议的内容，并在应用程序中进行公示。修改后的协议一经公示即生效，用户应及时关注并遵守修改后的协议。本协议的解释、执行及争议解决均适用法律法规及相关规定，如有争议，双方应友好协商解决；协商不成的，应向我们所在地有管辖权的人民法院提起诉讼解决。
        </p>
      </section>
  
      <section class="section">
        <h2 class="section-title">联系我们：</h2>
        <p class="section-content">
          如有任何关于本协议的问题、意见或建议，请联系我们：<br>
          杭州初六科技有限公司<br>
          17374480406
        </p>
      </section>
    </div>
  </template>
  
  <script>
  export default {
    created() {
        document.title = "充值协议"
    },
    name: "RechargeAgreement",
  };
  </script>
  
  <style scoped>
  .recharge-agreement {
    margin: 20px;
  }
  
  .agreement-title {
  color: #007BFF;
  font-size: 24px;
  margin-bottom: 20px;
}

.section {
  margin-bottom: 20px;
}

.section-title {
  color: #333;
  font-size: 20px;
  margin-bottom: 10px;
  text-align: left; /* 左对齐 */
}

.section-content {
  margin-left: 0; /* 调整段落左边距为 0 */
  text-align: left; /* 左对齐 */
}

  
  </style>
  